import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** EPOS javascript SDK adapted for Telavox use
 * Original SDK available here: https://dseasdk.com/common/js/dseasdk.v1.js
 * Test site available here: https://dseasdk.com/demo/CCL.html
 */

/* eslint-disable */

import { EventEmitter } from 'events';

//EPOS USB vendor ID dummy
var EPOSVID = 0x1395;
var ABLID = 'Sennheiser_UI_20_BL_USB';

//general string functions
function dec2hexStringSimple(dec) {
  return (dec + 0x10000).toString(16).substr(-2).toUpperCase();
}
function dec2hexString(dec) {
  return '0x' + dec2hexStringSimple(dec);
}
//Device helper functions
function getDeviceID(dev) {
  var name = getDeviceName(dev).replaceAll(' ', '_');
  return name;
}
function getDeviceName(dev) {
  var name = dev.productName;
  name = name.replace('Sennheiser Sennheiser ', 'Sennheiser ');
  name = name.replaceAll('EPOS ', '');
  name = name.replace('Secom Sennheiser ', 'Sennheiser ');
  name = name.replace('SeCom Sennheiser ', 'Sennheiser ');
  return name;
}
var _version_str = '0.7';

//Libraries
var dseasdk = /*#__PURE__*/function (_EventEmitter) {
  function dseasdk() {
    var _this;
    var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var _name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var forceHID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var logFunction = arguments.length > 4 ? arguments[4] : undefined;
    _classCallCheck(this, dseasdk);
    _this = _callSuper(this, dseasdk);
    _defineProperty(_this, "_postEvent", function (name, param) {
      setTimeout(function () {
        _this.emit(name, param);
      }, 0);
    });
    _defineProperty(_this, "_acknowledgement", function (jsonData) {
      var evnt = jsonData.Event;
      var callid = jsonData.CallID;
      if (parseInt(jsonData.ReturnCode) !== 0) {
        this.mylog.error('ErrorCode ' + evnt + ' (' + jsonData.ReturnCode + ')');
        return;
      }
      if (evnt === 'EstablishConnection') {
        this.mylog.message('receiving EstablishConnection');
        this._postEvent('LoginStatusChanged', 'EstablishConnection');
        this.wsConnected = true;
        this._systeminfo();
        return;
      }
      if (evnt === 'TerminateConnection') {
        this.mylog.message('receiving TerminateConnection');
        this._postEvent('LoginStatusChanged', 'TerminateConnection');
        this.wsConnected = false;
        this.ws.close();
        return;
      }
      if (!this.wsConnected) return;
      if (evnt === 'SystemInformation') {
        this.mylog.message('receiving SystemInformation: ' + jsonData.ProductName + ' version: ' + jsonData.ProductVersion);
        this._postEvent('SystemInformation', jsonData.ProductName + ' v. ' + jsonData.ProductVersion);
        return;
      }
      if (evnt === 'SPLoggedIn') {
        this.mylog.message('receiving SPLoggedIn');
        this._postEvent('LoginStatusChanged', 'SPLoggedIn');
        this._postEvent('BLsPresent', -1);
        this.wsLoggedIn = true;
        return;
      }
      if (evnt === 'SPLoggedOut') {
        this.mylog.message('receiving SPLoggedOut');
        this._postEvent('LoginStatusChanged', 'SPLoggedOut');
        this._postEvent('BLsPresent', 0);
        this.wsLoggedIn = false;
        return;
      }
      if (this.wsLoggedIn) {
        if (callid === undefined) this.mylog.message('acknowledgement:' + evnt);else this.mylog.message('acknowledgement:' + evnt + ' callid:' + callid);
      }
    });
    _defineProperty(_this, "_notification", function (jsonData) {
      var evnt = jsonData.Event;
      var callid = jsonData.CallID;
      //mylog.message("notification:" + evnt + " callid:" +callid);

      if (evnt === 'SocketConnected') {
        this.mylog.message('receiving SocketConnected');
        this._postEvent('LoginStatusChanged', 'SocketConnected');
        this.start();
      } else if (evnt === 'HeadsetConnected') {
        this.mylog.message('receiving HeadsetConnected');
        this._postEvent('HeadsetConnected', jsonData.HeadsetName);
      } else if (evnt === 'HeadsetDisconnected') {
        this.mylog.message('receiving HeadsetDisconnected');
        this._postEvent('HeadsetDisconnected', jsonData.HeadsetName);
      } else if (evnt === 'MuteSoftphone') {
        this.mylog.message('receiving MuteSoftphone');
        this._postEvent('MuteMicrophone', true);
      } else if (evnt === 'UnmuteSoftphone') {
        this.mylog.message('receiving UnmuteSoftphone');
        this._postEvent('MuteMicrophone', false);
      } else if (evnt === 'InCallAccepted') {
        this.mylog.message('receiving InCallAccepted ' + callid);
        this._postEvent('AcceptCall', callid);
      } else if (evnt === 'InCallRejected') {
        this.mylog.message('receiving InCallRejected');
        this._postEvent('RejectCall', callid);
      } else if (evnt === 'CallEnded') {
        this.mylog.message('receiving CallEnded');
        this._postEvent('EndCall', callid);
      } else if (evnt === 'CallHold') {
        this.mylog.message('receiving CallHold');
        this._postEvent('HoldCall', callid);
      } else if (evnt === 'HeldCallResumed') {
        this.mylog.message('receiving HeldCallResumed');
        this._postEvent('ResumeCall', callid);
      } else if (evnt === 'ListenerClosed') {
        this.mylog.message('ListenerClosed received');
        this.SendTerminateEvent();
      } else if (evnt === 'BLsPresent') {
        this.mylog.message('receiving BLsPresent');
        this._postEvent('BLsPresent', jsonData.ablDevices);
      } else if (evnt === 'HeadsetAvailable') {
        this.mylog.message('receiving HeadsetAvailable');
        var data = {
          name: jsonData.HeadsetName,
          id: jsonData.HeadsetPath,
          serial: '',
          firmware: '',
          vid: '',
          pid: ''
        };
        this._postEvent('HeadsetAvailable', data);
      } else if (evnt === 'HeadsetRemoved') {
        this.mylog.message('receiving HeadsetRemoved');
        var _data = {
          name: jsonData.HeadsetName,
          id: jsonData.HeadsetPath,
          serial: '',
          firmware: '',
          vid: '',
          pid: ''
        };
        this._postEvent('HeadsetRemoved', _data);
      } else if (evnt === 'Redial') {
        this.mylog.message('receiving Redial');
        this._postEvent('Redial', 0);
      } else if (evnt === 'Offhook') {
        this.mylog.message('receiving Offhook');
        this._postEvent('Offhook', 0);
      } else if (evnt === 'InCallAcceptedOnOffhook') {
        this.mylog.message('receiving InCallAcceptedOnOffhook');
        this._postEvent('InCallAcceptedOnOffhook', jsonData);
      } else {
        this.mylog.error('Unhandled notification received ' + evnt);
      }
    });
    _defineProperty(_this, "send", function (json) {
      if (!this.wsWorking) return;
      this.ws.send(JSON.stringify(json));
    });
    _defineProperty(_this, "start", function () {
      this.mylog.message('sending EstablishConnection');
      var obj = {
        Event: 'EstablishConnection',
        EventType: 'Request',
        SPIconImage: 'SPImage.ico',
        AudioDeviceChangesSupport: 'Yes',
        DNDOption: 'Yes',
        MuteSupport: 'Yes',
        RedialSupport: 'No',
        OffHookSupport: 'No'
      };
      obj.SPName = 'Softphone::' + this.name;
      this.send(obj);
    });
    _defineProperty(_this, "_systeminfo", function () {
      if (!this.wsWorking && this.webhidsdk !== null) {
        this._postEvent('SystemInformation', 'DSEA Call Control JS Library v. ' + _version_str);
        return;
      }
      this.mylog.message('sending SystemInformation');
      this.send({
        Event: 'SystemInformation',
        EventType: 'Request'
      });
    });
    _defineProperty(_this, "SendLoginEvent", function () {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.open();
        this._postEvent('LoginStatusChanged', 'SPLoggedInHID');
        this._systeminfo();
        return;
      }
      if (!this.wsConnected) return;
      this.mylog.message('sending SPLoggedIn');
      this.send({
        Event: 'SPLoggedIn',
        EventType: 'Request'
      });
    });
    _defineProperty(_this, "SendLogoutEvent", function () {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.close();
        this._postEvent('LoginStatusChanged', 'SPLoggedOutHID');
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending SPLoggedOut');
      this.send({
        Event: 'SPLoggedOut',
        EventType: 'Request'
      });
    });
    _defineProperty(_this, "SendTerminateEvent", function () {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.close();
        this._postEvent('LoginStatusChanged', 'TerminateConnection');
        return;
      }
      if (this.wsLoggedIn) this.SendLogoutEvent();
      if (!this.wsConnected) return;
      this.mylog.message('sending TerminateConnection');
      this.send({
        Event: 'TerminateConnection',
        EventType: 'Request'
      });
    });
    _defineProperty(_this, "SendMuteStatus", function (mute) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.mute(mute);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.muteStatus = mute;
      if (this.muteStatus) {
        this.mylog.message('sending MuteHeadset');
        this.send({
          Event: 'MuteHeadset',
          EventType: 'Request'
        });
      } else {
        this.mylog.message('sending UnmuteHeadset');
        this.send({
          Event: 'UnmuteHeadset',
          EventType: 'Request'
        });
      }
    });
    _defineProperty(_this, "SendIncomingCallEvent", function (callid) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.incoming(callid);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending IncomingCall ' + callid);
      this.send({
        Event: 'IncomingCall',
        EventType: 'Request',
        CallID: callid
      });
    });
    _defineProperty(_this, "SendOutgoingCallEvent", function (callid) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this.webhidsdk.outgoing(callid);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending OutgoingCall ' + callid);
      this.send({
        Event: 'OutgoingCall',
        EventType: 'Request',
        CallID: callid
      });
    });
    _defineProperty(_this, "SendEndCallEvent", function (callid) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.end(callid);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending CallEnded ' + callid);
      this.send({
        Event: 'CallEnded',
        EventType: 'Request',
        CallID: callid
      });
    });
    _defineProperty(_this, "SendHoldCallEvent", function (callid) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.hold(callid);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending CallHold ' + callid);
      this.send({
        Event: 'CallHold',
        EventType: 'Request',
        CallID: callid
      });
    });
    _defineProperty(_this, "SendUnholdCallEvent", function (callid) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        //webhidsdk.unhold(callid); // Not implemented
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending HeldCallResumed ' + callid);
      this.send({
        Event: 'HeldCallResumed',
        EventType: 'Request',
        CallID: callid
      });
    });
    _defineProperty(_this, "SendActiveCallEvent", function (callid) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.active(callid);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending InCallAccepted');
      this.send({
        Event: 'InCallAccepted',
        EventType: 'Request',
        CallID: callid
      });
    });
    _defineProperty(_this, "SendPresenceEvent", function (state) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.setBLPresence(state);
        return;
      }
      if (!this.wsLoggedIn) return;
      this.mylog.message('sending SendPresenceEvent ' + state);
      this.send({
        Event: 'SetPresence',
        EventType: 'Request',
        State: state
      });
    });
    _defineProperty(_this, "SendActiveDeviceChanged", function (supported, hs) {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.headset(hs);
        return;
      }
      if (!this.wsLoggedIn) return;
      var status = 1;
      if (!supported) status = 0;
      this.mylog.message('sending ActiveDeviceChanged ' + hs);
      this.send({
        Event: 'ActiveDeviceChanged',
        EventType: 'Request',
        HSSTATUS: status,
        HeadsetPath: hs
      });
    });
    _defineProperty(_this, "AllowHS", function () {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.select();
        return;
      }
    });
    _defineProperty(_this, "AllowBL", function () {
      if (!this.wsWorking && this._webhidsdk !== null) {
        this._webhidsdk.selectBL();
        return;
      }
    });
    _this._webhidsdk = null;
    var this_ = _this;
    this_.brand = brand;
    this_.name = _name;
    this_.version = version;
    this_.forceHID = forceHID;
    if (logFunction) {
      _this.mylog = {
        message: logFunction,
        error: function error(log) {
          return logFunction('Error: ' + log);
        }
      };
    } else {
      _this.mylog = new log('LightGreen', 'PaleGreen');
      _this.mylog.message('dseacallcontrollibrary initialized');
    }
    _this.ws = undefined;
    _this.wsWorking = false;
    _this.wsConnected = false;
    _this.wsLoggedIn = false;
    _this.muteStatus = false;
    var socketopen = function socketopen() {
      _this.mylog.message('Socket Opened');
      _this.wsWorking = true;
    };
    var socketclose = function socketclose() {
      _this.mylog.message('Socket Closed');
      _this.wsWorking = false;
      if (navigator.hid && this_.forceHID >= 0) {
        _this._webhidsdk = new webhid(this_.brand, this_.name, this_.version);
        _this._postEvent('LoginStatusChanged', 'EstablishConnection');
      }
    };
    var socketmessage = function socketmessage(evt) {
      if (!_this.wsWorking) return;
      var jsonData = JSON.parse(evt.data);
      if (jsonData.EventType === 'Acknowledgement') _this._acknowledgement(jsonData);else if (jsonData.EventType === 'Notification') _this._notification(jsonData);else _this.mylog.error('Unhandled Acknowledgement received ' + evt.data);
    };
    if (forceHID > 0) {
      _this.mylog.message('Forcing webHID');
      if (navigator.hid) {
        _this._webhidsdk = new webhid(this_.brand, this_.name, this_.version, true);
        _this._postEvent('LoginStatusChanged', 'EstablishConnection');
      }
    } else {
      _this.ws = new WebSocket('wss://127.0.0.1:41088');
      _this.ws.onopen = socketopen;
      _this.ws.onmessage = socketmessage;
      _this.ws.onclose = socketclose;
    }
    return _this;
  }
  _inherits(dseasdk, _EventEmitter);
  return _createClass(dseasdk);
}(EventEmitter);
function log(maincolor, secondarycolor) {
  var this_ = this;
  this_.active = true;
  this_.color1 = maincolor;
  this_.color2 = secondarycolor;
  var messageMax = 81;
  var reportMax = 40;
  var format = 'padding: 3px;height: 18px; line-height: 18px;font-size: 12px;';
  var border = 'border:1px solid black;';
  var bordertlr = 'border-top:1px solid black;border-left:1px solid black;border-right:1px solid black;';
  var ERRORCOLOR = 'Crimson';
  var INITCOLOR = 'Khaki';
  var CONNECTIONCOLOR = 'DarkKhaki';
  function brightness(r, g, b) {
    return Math.sqrt(r * r * 0.241 + g * g * 0.691 + b * b * 0.068);
  }
  this.activate = function () {
    var act = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    this_.active = act;
  };
  this.image = function (url) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    if (!this_.active) return;
    var image = new Image();
    image.onload = function () {
      var style = ['font-size: 1px;', 'border: 1px solid black;', 'padding: ' + size + 'px ' + size + 'px;', 'background: ' + this_.color2 + ' url(' + url + ') no-repeat;', 'background-size: contain;'].join(' ');
      console.log('%c ', style);
    };
    image.src = url;
  };
  this.led = function (msg, r, g, b) {
    if (!this_.active) return;
    while (msg.length < messageMax - 6) msg = msg + ' ';
    var args = [];
    args.push('%c   %c %c' + msg);
    args.push(format + 'border: 1px solid black;border-radius: 50%;background: rgb(' + r + ',' + g + ',' + b + ')');
    args.push(format);
    args.push(format + border + 'background:' + this_.color2 + ';');
    console.log.apply(this, args);
  };
  this.error = function (msg) {
    this.message(msg, ERRORCOLOR);
  };
  this.connection = function (msg) {
    this.message(msg, CONNECTIONCOLOR);
  };
  this.init = function (msg) {
    this.message(msg, INITCOLOR);
  };
  this.message = function (msg) {
    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (!this_.active) return;
    if (color === '') color = this_.color2;
    while (msg.length < messageMax) {
      msg = ' ' + msg;
      if (msg.length < messageMax) msg = msg + ' ';
    }
    console.log('%c' + msg, format + border + 'background:' + color + ';');
  };
  this.report = function (data, name, statename) {
    var headercolor = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var itemcolor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    if (!this_.active) return;
    if (headercolor === '') headercolor = this_.color1;
    if (itemcolor === '') itemcolor = this_.color2;
    var header = '%c' + name + ' (' + statename + ')';
    while (header.length < reportMax) header += ' ';
    for (i = 0; i < data.length; i++) {
      header += '%c\n';
      item = '%c ' + i + ' ' + data[i][0];
      while (item.length < reportMax - data[i][1].toString().length - 2) item += ' ';
      item += ' ' + data[i][1] + ' ';
      header += item;
    }
    margin = '';
    if (name.toUpperCase().substr(0, 5) === 'INPUT') margin = 'margin-left: 283px;';
    var args = [];
    args.push(header);
    args.push(format + bordertlr + margin + 'background:' + headercolor + ';');
    for (j = 0; j < data.length; j++) {
      args.push('');
      if (j === data.length - 1) args.push(format + border + margin + 'background:' + itemcolor + ';');else args.push(format + bordertlr + margin + 'background:' + itemcolor + ';');
    }
    console.log.apply(this, args);
  };
  this.jsonreport = function (name, data) {
    if (!this_.active) return;
    var header = '%c' + name;
    while (header.length < messageMax + 2) header += ' ';
    cnt = 0;
    for (var key in data) {
      if (Array.isArray(data[key])) {
        if (key === 'configSettings') for (var kk in data[key]) {
          header += '%c\n';
          line = data[key][kk]['FeatureName'];
          while (line.length < (messageMax - 3) / 2) line = ' ' + line;
          line = ' ' + line;
          line += ' : ';
          y = 0;
          str = data[key][kk].FeatureValue;
          while (line.length < messageMax - 1) if (y >= str.length) line += ' ';else line += str[y++];
          line += ' ';
          header += '%c' + line;
          cnt++;
        }
      } else {
        header += '%c\n';
        line = key;
        while (line.length < (messageMax - 3) / 2) line = ' ' + line;
        line = ' ' + line;
        line += ' : ';
        y = 0;
        str = '';
        if (data[key] !== null) str = data[key].toString();
        while (line.length < messageMax - 1) if (y >= str.length) line += ' ';else line += str[y++];
        line += ' ';
        header += '%c' + line;
        cnt++;
      }
    }
    var args = [];
    args.push(header);
    args.push(format + bordertlr + 'background:' + this_.color1 + ';');
    for (j = 0; j < cnt; j++) {
      args.push('');
      if (j === cnt - 1) args.push(format + border + 'background:' + this_.color2 + ';');else args.push(format + bordertlr + 'background:' + this_.color2 + ';');
    }
    console.log.apply(this, args);
  };
}
function abl(loaded) {
  var this_ = this;
  this_.callback = loaded;
  var MYCOLOR1 = 'PaleVioletRed';
  var MYCOLOR2 = 'LightPink';
  var UBL20 = 0x0074;
  var myABLs = [];
  var mylog = null;
  this.presence = function (thecolor) {
    this_.color(thecolor, 1);
  };
  this.color = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(thecolor, oc) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(thecolor.length !== 7 || thecolor[0] !== '#')) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            colordec = parseInt(thecolor.replace('#', '0x'));
            r = (colordec & 0xff0000) >> 16;
            g = (colordec & 0x00ff00) >> 8;
            b = (colordec & 0x0000ff) >> 0;
            buffer = new Uint8Array(63);
            buffer.fill(0);
            x = 0;
            //buffer[x++] = 1;
            buffer[x++] = 18;
            buffer[x++] = 2;
            buffer[x++] = r;
            buffer[x++] = g;
            buffer[x++] = b;
            buffer[x++] = r;
            buffer[x++] = g;
            buffer[x++] = b;
            buffer[x++] = oc;
            buffer[x++] = 0xff; //Flash count
            buffer[x++] = 0xff;
            buffer[x++] = 0xff;
            buffer[x++] = 0xff;
            if (oc === 2) {
              buffer[x++] = 0; //on time
              buffer[x++] = 4;
              buffer[x++] = 0; //off time
              buffer[x++] = 4;
            }
            for (i = 0; i < myABLs.length; i++) {
              if (myABLs[i].device.opened) {
                myABLs[i].device.sendReport(1, buffer)["catch"](function (error) {
                  mylog.error('Error in SendReport abl::color ' + error);
                });
              }
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  this.select = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (navigator.hid) {
            _context2.next = 1;
            break;
          }
          alert('navigator.hid not defined - Use Chrome 89+ or install EPOS Connect');
          return _context2.abrupt("return");
        case 1:
          filters = [{
            vendorId: EPOSVID,
            productId: UBL20
          }];
          _context2.next = 2;
          return navigator.hid.requestDevice({
            filters: filters
          });
        case 2:
          device = _context2.sent;
          if (!(device.length === 0)) {
            _context2.next = 3;
            break;
          }
          return _context2.abrupt("return");
        case 3:
          dev = device[0];
          found = false;
          for (i = 0; i < myABLs.length; i++) if (dev === myABLs[i].device) found = true;
          if (!found) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return");
        case 4:
          mylog.message('Adding device ' + dev.productName);
          addDevice(dev);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  this.play = function (tone, mode, repetition) {
    buffer = new Uint8Array(63);
    buffer.fill(0);
    x = 0;
    //buffer[x++] = 1;
    buffer[x++] = 9;
    buffer[x++] = 4;
    buffer[x++] = tone;
    buffer[x++] = mode;
    buffer[x++] = (repetition & 0x000000ff) >> 0;
    buffer[x++] = (repetition & 0x0000ff00) >> 8;
    buffer[x++] = (repetition & 0x00ff0000) >> 16;
    buffer[x++] = (repetition & 0xff000000) >> 24;
    for (i = 0; i < myABLs.length; i++) {
      if (myABLs[i].device.opened) {
        buffer[2] = myABLs[i].ringtone;
        myABLs[i].device.sendReport(1, buffer)["catch"](function (error) {
          mylog.error('Error in SendReport abl::play ' + error);
        });
      }
    }
  };
  this.open = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 1;
          return init();
        case 1:
          this_.callback('loaded');
        case 2:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  this.close = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          this_.color('#000000', 1);
          for (i = myABLs.length - 1; i >= 0; i--) {
            if (myABLs[i].device.opened) {
              mylog.message('Device removed ' + myABLs[i].device.productName);
              myABLs[i].device.close();
              myABLs.splice(i, 1);
            }
          }
          myABLs = [];
          this_.callback('devices', 0);
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  function onInputReport(event) {
    inputReportBuffer = new Uint8Array(event.data.buffer);
    len = parseInt(inputReportBuffer[0]);
    cmd = parseInt(inputReportBuffer[1]);
    if (cmd === 1) {
      if (inputReportBuffer[27] & 8) {
        for (i = 0; i < myABLs.length; i++) {
          if (myABLs[i].device == event.device) {
            myABLs[i].ringtone = 3;
          }
        }
      }
    }
  }
  if (navigator.hid) {
    navigator.hid.addEventListener('connect', /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref5) {
        var device;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              device = _ref5.device;
              if (device.productId === UBL20) {
                mylog.connection("HID connected: ".concat(device.productName));
                addDevice(device);
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    navigator.hid.addEventListener('disconnect', function (_ref7) {
      var device = _ref7.device;
      if (device.productId === UBL20) {
        mylog.connection("HID disconnected: ".concat(device.productName));
        for (i = 0; i < myABLs.length; i++) {
          if (myABLs[i].device === device) {
            mylog.message('Device removed ' + device.productName);
            myABLs[i].device.close();
            myABLs.splice(i, 1);
            this_.callback('devices', myABLs.length);
            return;
          }
        }
      }
    });
  }
  function status(dev) {
    buffer = new Uint8Array(63);
    buffer.fill(0);
    x = 0;
    buffer[x++] = 3;
    buffer[x++] = 1;
    dev.sendReport(1, buffer)["catch"](function (error) {
      console.log('Error in status ' + error);
    });
  }
  var addDevice = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dev) {
      return _regeneratorRuntime.wrap(function (_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if (!(dev.productId !== UBL20)) {
              _context6.next = 1;
              break;
            }
            return _context6.abrupt("return");
          case 1:
            dev.open().then(function () {
              if (dev.opened) {
                var _device = {};
                _device.device = dev;
                _device.serial = '';
                _device.firmware = '';
                _device.wait = 0;
                _device.number = myABLs.length;
                _device.vid = parseInt(EPOSVID);
                _device.pid = parseInt(UBL20);
                _device.id = getDeviceID(dev);
                _device.ringtone = 0;
                myABLs.push(_device);
                this_.callback('devices', myABLs.length);
                this_.color('#000000', 1);
                dev.oninputreport = onInputReport;
                status(dev);
              }
            });
          case 2:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function addDevice(_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
  var init = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _devices, promises;
      return _regeneratorRuntime.wrap(function (_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!navigator.hid) {
              _context8.next = 3;
              break;
            }
            _context8.next = 1;
            return navigator.hid.getDevices();
          case 1:
            _devices = _context8.sent;
            _context8.next = 2;
            return _devices.map(/*#__PURE__*/function () {
              var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dev) {
                var numFruit;
                return _regeneratorRuntime.wrap(function (_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 1;
                      return addDevice(dev);
                    case 1:
                      numFruit = _context7.sent;
                      return _context7.abrupt("return", numFruit);
                    case 2:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }));
              return function (_x5) {
                return _ref0.apply(this, arguments);
              };
            }());
          case 2:
            promises = _context8.sent;
            _context8.next = 3;
            return Promise.all(promises);
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function init() {
      return _ref9.apply(this, arguments);
    };
  }();
  mylog = new log(MYCOLOR1, MYCOLOR2);
}
function webhid() {
  var brand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var this_ = this;
  this_.name = name;
  this_.brand = brand;
  this_.version = version;
  //helper for writing to the console
  var mylog = null;

  //Colors for the console logging
  var MYCOLOR1 = 'LightSkyBlue';
  var MYCOLOR2 = 'LightBlue';

  //helper for managing connected ABL devices
  var myabl = null;
  //Presence color in #rrggbb format
  var presence = '';
  var firstring = true;

  //current headset
  var myHSs = [];
  var deviceIsSupported = true;

  //mute status of current headset
  var mute = false;
  //all current calls
  //map from callid to json
  //state : none,incoming,outgoing,active,onhold
  //created: seconds since 1970. used as incoming calls are answer FIFO
  //active: seconds since 1970. used as held calls are unheld LIFO
  //type: incoming, outgoing, other
  var calls = new Map();
  var led_vendor_bit3 = 128;

  //all access to headset through the main and alternate vendor pages
  var VENDORPAGE = 0xffff;
  var ALTVENDORPAGE = 0xff58;
  var ALTVENDORPAGE2 = 0xff58;

  //12 states of call control
  var IDLE = 0;
  var INCOMING = 1;
  var HOLDING = 2;
  var INCOMING_HOLDING = 3;
  var OUTGOING = 4;
  var OUTGOING_INCOMING = 5;
  var OUTGOING_HOLDING = 6;
  var OUTGOING_INCOMING_HOLDING = 7;
  var ACTIVE = 8;
  var ACTIVE_INCOMING = 9;
  var ACTIVE_HOLDING = 10;
  var ACTIVE_INCOMING_HOLDING = 11;
  var UNKNOWN = 12;
  //create or change a call into incoming state - sdk accepts as unlimited number of calls in incoming state. incoming calls are answer FIFO
  this.incoming = function (callid) {
    if (!calls.has(String(callid))) calls.set(String(callid), {
      state: 'none',
      created: Date.now(),
      active: 0,
      type: 'incoming',
      started: new Date()
    });else if (calls.get(String(callid)).state === 'incoming') return;
    calls.get(String(callid)).state = 'incoming';
    updateHeadset();
  };

  //create or change a call into outgoing state - sdk accepts maximum 1 outgoing or active call at the time
  this.outgoing = function (callid) {
    if (!calls.has(String(callid))) calls.set(String(callid), {
      state: 'none',
      created: Date.now(),
      active: 0,
      type: 'outgoing',
      started: new Date()
    });else if (calls.get(String(callid)).state === 'outgoing') return;
    var _iterator = _createForOfIteratorHelper(calls.keys()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        if (key !== String(callid)) {
          if (calls.get(key).state === 'outgoing') {
            calls["delete"](String(key));
            postEvent('EndCall', key);
          } else if (calls.get(key).state === 'active') {
            calls.get(key).state = 'onhold';
            postEvent('HoldCall', key);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    calls.get(String(callid)).state = 'outgoing';
    updateHeadset();
  };
  //create or change a call into active state - sdk accepts maximum 1 active or outgoing call at the time
  this.active = function (callid) {
    if (!calls.has(String(callid))) calls.set(String(callid), {
      state: 'none',
      created: Date.now(),
      active: 0,
      type: 'other',
      started: new Date()
    });else if (calls.get(String(callid)).state === 'active') return;
    var _iterator2 = _createForOfIteratorHelper(calls.keys()),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var key = _step2.value;
        if (key !== String(callid)) {
          if (calls.get(key).state == 'outgoing') {
            calls["delete"](String(key));
            postEvent('EndCall', key);
          } else if (calls.get(key).state == 'active') {
            calls.get(key).state = 'onhold';
            postEvent('HoldCall', key);
          }
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    calls.get(String(callid)).state = 'active';
    calls.get(String(callid)).active = Date.now();
    updateHeadset();
  };
  //create or change a call into onhold state - sdk accepts unlimited number of call on hold.
  this.hold = function (callid) {
    if (!calls.has(String(callid))) calls.set(String(callid), {
      state: 'none',
      created: Date.now(),
      active: Date.now(),
      type: 'other',
      started: new Date()
    });else if (calls.get(String(callid)).state === 'onhold') return;
    calls.get(String(callid)).state = 'onhold';
    updateHeadset();
  };

  //ends a call
  this.end = function (callid) {
    if (calls.has(String(callid))) {
      calls["delete"](String(callid));
      updateHeadset();
    }
  };
  function setTheDefaultHeadset() {
    return _setTheDefaultHeadset.apply(this, arguments);
  }
  function _setTheDefaultHeadset() {
    _setTheDefaultHeadset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
      return _regeneratorRuntime.wrap(function (_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            initHeadset();
          case 1:
          case "end":
            return _context14.stop();
        }
      }, _callee14);
    }));
    return _setTheDefaultHeadset.apply(this, arguments);
  }
  function finddevices() {
    return _finddevices.apply(this, arguments);
  } //opens the sdk, call upon login
  function _finddevices() {
    _finddevices = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
      return _regeneratorRuntime.wrap(function (_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            myabl.open();
            _context15.next = 1;
            return initHeadsetList();
          case 1:
            setTimeout(setTheDefaultHeadset, 2000);
          case 2:
          case "end":
            return _context15.stop();
        }
      }, _callee15);
    }));
    return _finddevices.apply(this, arguments);
  }
  this.open = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function (_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          finddevices();
        case 1:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));

  //closes the sdk, please call upon window.onbeforeunload
  this.close = function () {
    closeHeadsetList();
    myabl.close();
  };

  //manipulates the mute state of the headset
  this.mute = function (ismute) {
    mute = ismute;
    updateHeadset();
  };

  //display the webHID device dialog for device selection
  this.select = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
    return _regeneratorRuntime.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          if (navigator.hid) {
            _context0.next = 1;
            break;
          }
          alert('navigator.hid not defined - Use Chrome 89+ or install EPOS Connect');
          return _context0.abrupt("return");
        case 1:
          filters = [{
            usagePage: VENDORPAGE,
            vendorId: EPOSVID
          }, {
            usagePage: ALTVENDORPAGE,
            vendorId: EPOSVID
          }, {
            usagePage: ALTVENDORPAGE2,
            vendorId: EPOSVID
          }];
          //filters = [{vendorId: EPOSVID}];
          _context0.next = 2;
          return navigator.hid.requestDevice({
            filters: filters
          });
        case 2:
          devices = _context0.sent;
          if (!(devices.length === 0)) {
            _context0.next = 3;
            break;
          }
          return _context0.abrupt("return");
        case 3:
          dev = devices[0];

          //console.log(dev);
          i = 0;
        case 4:
          if (!(i < myHSs.length)) {
            _context0.next = 6;
            break;
          }
          if (!(myHSs[i].device === dev)) {
            _context0.next = 5;
            break;
          }
          return _context0.abrupt("continue", 6);
        case 5:
          i++;
          _context0.next = 4;
          break;
        case 6:
          deviceIsSupported = true;
          if (!(i === myHSs.length)) {
            _context0.next = 8;
            break;
          }
          _context0.next = 7;
          return addNewHeadset(dev);
        case 7:
          _context0.next = 10;
          break;
        case 8:
          if (!(i > 0)) {
            _context0.next = 9;
            break;
          }
          //anden fra listen
          myHSs.splice(0, 0, myHSs.splice(i, 1)[0]);
          _context0.next = 10;
          break;
        case 9:
          return _context0.abrupt("return");
        case 10:
          //allerede current

          initHeadset();
        case 11:
        case "end":
          return _context0.stop();
      }
    }, _callee0);
  }));

  //Function to retreive and report info of device
  function reportAvailability(headset) {
    mylog.message('New device available ' + headset.name);
    var data = {
      name: headset.name,
      id: headset.id,
      serial: headset.serial,
      firmware: headset.firmware,
      vid: headset.vid,
      pid: headset.pid
    };
    postEvent('HeadsetAvailable', data);
  }
  //Function to select new default device
  this.headset = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(devname) {
      return _regeneratorRuntime.wrap(function (_context1) {
        while (1) switch (_context1.prev = _context1.next) {
          case 0:
            console.log(devname);
            i = 0;
          case 1:
            if (!(i < myHSs.length)) {
              _context1.next = 3;
              break;
            }
            console.log(i + ' ' + myHSs[i].name);
            if (!(myHSs[i].name === devname)) {
              _context1.next = 2;
              break;
            }
            deviceIsSupported = true;
            if (i !== 0)
              //anden fra listen
              myHSs.splice(0, 0, myHSs.splice(i, 1)[0]);
            initHeadset();
            mylog.message('New device selected ' + myHSs[0].name);
            return _context1.abrupt("return");
          case 2:
            i++;
            _context1.next = 1;
            break;
          case 3:
            //Softphone gchanged to a non EPOS device
            mylog.message('Non EPOS device selected ' + devname);
            if (myHSs.length) postEvent('HeadsetDisconnected', myHSs[0].name);
            deviceIsSupported = false;
          case 4:
          case "end":
            return _context1.stop();
        }
      }, _callee1);
    }));
    return function (_x6) {
      return _ref11.apply(this, arguments);
    };
  }();

  //display the webHID device dialog to select ABL device
  this.selectBL = function () {
    myabl.select();
  };

  //sets the presence color of the ABL - presence color is used when not in a call
  this.setBLPresence = function (hex) {
    hex = hex.toUpperCase();
    presence = hex;
    updateHeadset();
  };

  //function to format HID reports for console logging
  function logInputReport(statename, _byte) {
    var report = [['', 0], ['', 0], ['', 0], ['', 0], ['', 0], ['', 0], ['', 0], ['', 0]];
    for (i = 0; i < 8; i++) {
      if (myHSs[0].telephony_hook === 1 << i) {
        report[i][0] = 'Hook';
        if ((_byte & myHSs[0].telephony_hook) > 0) report[i][1] = 1;
      }
      if (myHSs[0].telephony_flash === 1 << i) {
        report[i][0] = 'Flash';
        if ((_byte & myHSs[0].telephony_flash) > 0) report[i][1] = 1;
      }
      if (myHSs[0].telephony_redial === 1 << i) {
        report[i][0] = 'Redial';
        if ((_byte & myHSs[0].telephony_redial) > 0) report[i][1] = 1;
      }
      if (myHSs[0].telephony_mute === 1 << i) {
        report[i][0] = 'Mute';
        if ((_byte & myHSs[0].telephony_mute) > 0) report[i][1] = 1;
      }
      if (myHSs[0].telephony_drop === 1 << i) {
        report[i][0] = 'Drop';
        if ((_byte & myHSs[0].telephony_drop) > 0) report[i][1] = 1;
      }
    }
    mylog.report(report, 'Input Report ' + myHSs[0].inputReportID, statename);
  }
  function logOutputReport(statename, _byte2) {
    var report = [['', 0], ['', 0], ['', 0], ['', 0], ['', 0], ['', 0], ['', 0], ['', 0]];
    for (i = 0; i < 8; i++) {
      if (myHSs[0].led_offhook === 1 << i) {
        report[i][0] = 'Offhook';
        if ((_byte2 & myHSs[0].led_offhook) > 0) report[i][1] = 1;
      }
      if (myHSs[0].led_microphone === 1 << i) {
        report[i][0] = 'Microphone';
        if ((_byte2 & myHSs[0].led_microphone) > 0) report[i][1] = 1;
      }
      if (myHSs[0].led_ring === 1 << i) {
        report[i][0] = 'Ring';
        if ((_byte2 & myHSs[0].led_ring) > 0) report[i][1] = 1;
      }
      if (myHSs[0].led_ringer === 1 << i) {
        report[i][0] = 'Ringer';
        if ((_byte2 & myHSs[0].led_ringer) > 0) report[i][1] = 1;
      }
      if (myHSs[0].led_mute === 1 << i) {
        report[i][0] = 'Mute';
        if ((_byte2 & myHSs[0].led_mute) > 0) report[i][1] = 1;
      }
      if (myHSs[0].led_online === 1 << i) {
        report[i][0] = 'Online';
        if ((_byte2 & myHSs[0].led_online) > 0) report[i][1] = 1;
      }
      if (myHSs[0].led_hold === 1 << i) {
        report[i][0] = 'Hold';
        if ((_byte2 & myHSs[0].led_hold) > 0) report[i][1] = 1;
      }
      if (led_vendor_bit3 === 1 << i) {
        report[i][0] = 'Vendor Page';
        if ((_byte2 & led_vendor_bit3) > 0) report[i][1] = 1;
      }
    }
    mylog.report(report, 'Output Report ' + myHSs[0].outputReportID, statename);
  }
  var addNewHeadset = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dev) {
      var headset;
      return _regeneratorRuntime.wrap(function (_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            found = false;
            for (x = 0; x < dev.collections.length; x++) if (dev.vendorId === EPOSVID && (dev.collections[x].usagePage === VENDORPAGE || dev.collections[x].usagePage === ALTVENDORPAGE || dev.collections[x].usagePage === ALTVENDORPAGE2)) found = true;
            if (found) {
              _context10.next = 1;
              break;
            }
            return _context10.abrupt("return");
          case 1:
            _context10.next = 2;
            return dev.open();
          case 2:
            if (dev.opened) {
              _context10.next = 3;
              break;
            }
            return _context10.abrupt("return");
          case 3:
            dev.oninputreport = onInputReport;
            headset = {};
            headset.device = dev;
            headset.serial = '';
            headset.firmware = '';
            headset.vid = parseInt(EPOSVID);
            headset.pid = parseInt(dev.productId);
            headset.id = getDeviceID(dev);
            headset.name = getDeviceName(dev);
            headset.slave1id = '';
            headset.slave1name = '';
            headset.slave1firmware = '';
            headset.slave1serial = '';
            headset.slave2id = '';
            headset.slave2name = '';
            headset.slave2firmware = '';
            headset.slave2serial = '';
            headset.slave1pid = 0;
            headset.slave2pid = 0;
            headset.Commands = [];
            headset.inputReportID = 0;
            headset.outputReportID = 0;
            headset.telephony_hook = 0;
            headset.telephony_flash = 0;
            headset.telephony_redial = 0;
            headset.telephony_mute = 0;
            headset.telephony_drop = 0;
            headset.led_ringer = 0; //0b00000001;
            headset.led_offhook = 0; //0b00000010;
            headset.led_microphone = 0; //0b00000100;
            headset.led_ring = 0; //0b00001000;
            headset.led_mute = 0; //0b00010000;
            headset.led_online = 0; //0b00100000;
            headset.led_hold = 0; //0b01000000;

            myHSs.unshift(headset);
            initWEBHIDheadset();
            if (deviceIsSupported) {
              mylog.message('New device selected ' + headset.name);
              postEvent('HeadsetConnected', headset.name);
            }
            reportAvailability(headset);
          case 4:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function addNewHeadset(_x7) {
      return _ref12.apply(this, arguments);
    };
  }();

  //function to search for EPOS headset and pick the right one
  function initHeadsetList() {
    return _initHeadsetList.apply(this, arguments);
  } //function for initializing current headset
  function _initHeadsetList() {
    _initHeadsetList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
      var devices, promises;
      return _regeneratorRuntime.wrap(function (_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (navigator.hid) {
              _context17.next = 1;
              break;
            }
            return _context17.abrupt("return");
          case 1:
            _context17.next = 2;
            return navigator.hid.getDevices();
          case 2:
            devices = _context17.sent;
            _context17.next = 3;
            return devices.map(/*#__PURE__*/function () {
              var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(dev) {
                var numFruit;
                return _regeneratorRuntime.wrap(function (_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      _context16.next = 1;
                      return addNewHeadset(dev);
                    case 1:
                      numFruit = _context16.sent;
                      return _context16.abrupt("return", numFruit);
                    case 2:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              return function (_x12) {
                return _ref18.apply(this, arguments);
              };
            }());
          case 3:
            promises = _context17.sent;
            _context17.next = 4;
            return Promise.all(promises);
          case 4:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    return _initHeadsetList.apply(this, arguments);
  }
  function initHeadset() {
    return _initHeadset.apply(this, arguments);
  } //function to analyze telephony collection of current headset
  function _initHeadset() {
    _initHeadset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
      return _regeneratorRuntime.wrap(function (_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            if (!(myHSs.length === 0)) {
              _context18.next = 1;
              break;
            }
            mylog.message('No headset connected');
            return _context18.abrupt("return");
          case 1:
            if (deviceIsSupported) {
              mylog.message('Device in use by SDK is: ' + myHSs[0].name);
              postEvent('HeadsetConnected', myHSs[0].name);
            }
            updateHeadset();
          case 2:
          case "end":
            return _context18.stop();
        }
      }, _callee18);
    }));
    return _initHeadset.apply(this, arguments);
  }
  function initWEBHIDheadset() {
    return _initWEBHIDheadset.apply(this, arguments);
  } //function to write current state to headset and ABL devices
  function _initWEBHIDheadset() {
    _initWEBHIDheadset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
      var telephonyCollection, outputSetup, inputSetup, _t, _t2, _t3;
      return _regeneratorRuntime.wrap(function (_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            telephonyCollection = null;
            for (x = 0; x < myHSs[0].device.collections.length; x++) {
              if (myHSs[0].device.collections[x].usagePage === VENDORPAGE) telephonyCollection = myHSs[0].device.collections[x];
            }
            if (telephonyCollection === null) {
              //For MODI....
              for (x = 0; x < myHSs[0].device.collections.length; x++) {
                if (myHSs[0].device.collections[x].usagePage === ALTVENDORPAGE) telephonyCollection = myHSs[0].device.collections[x];
              }
            }
            if (!(telephonyCollection === null)) {
              _context19.next = 1;
              break;
            }
            //This should never happen
            mylog.error('Device does not have Telephony Collection, using defaults');
            return _context19.abrupt("return");
          case 1:
            //console.log(myHSs[0].device);
            outputSetup = [];
            q = 0;
          case 2:
            if (!(q < telephonyCollection.outputReports.length)) {
              _context19.next = 21;
              break;
            }
            reportPos = 0;
            x = 0;
          case 3:
            if (!(x < telephonyCollection.outputReports[q].items.length)) {
              _context19.next = 20;
              break;
            }
            y = 0;
          case 4:
            if (!(y < telephonyCollection.outputReports[q].items[x].usages.length)) {
              _context19.next = 19;
              break;
            }
            usagePage = (telephonyCollection.outputReports[q].items[x].usages[y] & 0xff0000) >> 16;
            usage = telephonyCollection.outputReports[q].items[x].usages[y] & 0x0000ff;
            if (!(usagePage === 0x95)) {
              _context19.next = 14;
              break;
            }
            myHSs[0].outputReportID = telephonyCollection.outputReports[q].reportId;
            _t = usage;
            _context19.next = _t === 0x09 ? 5 : _t === 0x17 ? 6 : _t === 0x9e ? 7 : _t === 0x18 ? 8 : _t === 0x20 ? 9 : _t === 0x21 ? 10 : _t === 0x2a ? 11 : 12;
            break;
          case 5:
            //'led-mute'
            myHSs[0].led_mute = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 6:
            //'led-offhook'
            myHSs[0].led_offhook = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 7:
            //'led-ringer'
            myHSs[0].led_ringer = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 8:
            //'led-ring'
            myHSs[0].led_ring = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 9:
            //'led-hold'
            myHSs[0].led_hold = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 10:
            //'led-microphone'
            myHSs[0].led_microphone = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 11:
            //'led-online'
            myHSs[0].led_online = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 13);
          case 12:
            return _context19.abrupt("continue", 13);
          case 13:
            _context19.next = 17;
            break;
          case 14:
            if (!(usagePage === 0x13)) {
              _context19.next = 17;
              break;
            }
            _t2 = usage;
            _context19.next = _t2 === 0x9e ? 15 : 16;
            break;
          case 15:
            //'led-ringer'
            myHSs[0].led_ringer = 1 << reportPos;
            outputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 17);
          case 16:
            return _context19.abrupt("continue", 17);
          case 17:
            reportPos += telephonyCollection.outputReports[q].items[x].reportSize;
          case 18:
            y++;
            _context19.next = 4;
            break;
          case 19:
            x++;
            _context19.next = 3;
            break;
          case 20:
            q++;
            _context19.next = 2;
            break;
          case 21:
            mylog.report(outputSetup, 'Output', myHSs[0].outputReportID);
            inputSetup = [];
            q = 0;
          case 22:
            if (!(q < telephonyCollection.inputReports.length)) {
              _context19.next = 35;
              break;
            }
            reportPos = 0;
            x = 0;
          case 23:
            if (!(x < telephonyCollection.inputReports[q].items.length)) {
              _context19.next = 34;
              break;
            }
            y = 0;
          case 24:
            if (!(y < telephonyCollection.inputReports[q].items[x].usages.length)) {
              _context19.next = 33;
              break;
            }
            usagePage = (telephonyCollection.inputReports[q].items[x].usages[y] & 0xff0000) >> 16;
            usage = telephonyCollection.inputReports[q].items[x].usages[y] & 0x0000ff;
            if (!(usagePage === 0x13)) {
              _context19.next = 31;
              break;
            }
            myHSs[0].inputReportID = telephonyCollection.inputReports[q].reportId;
            _t3 = usage;
            _context19.next = _t3 === 0x20 ? 25 : _t3 === 0x21 ? 26 : _t3 === 0x24 ? 27 : _t3 === 0x2f ? 28 : _t3 === 0x26 ? 29 : 30;
            break;
          case 25:
            //telephony-hook'
            myHSs[0].telephony_hook = 1 << reportPos;
            inputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 31);
          case 26:
            //telephony-flash'
            myHSs[0].telephony_flash = 1 << reportPos;
            inputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 31);
          case 27:
            //telephony-redial'
            myHSs[0].telephony_redial = 1 << reportPos;
            inputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 31);
          case 28:
            //telephony-mute'
            myHSs[0].telephony_mute = 1 << reportPos;
            inputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 31);
          case 29:
            //telephony-drop'
            myHSs[0].telephony_drop = 1 << reportPos;
            inputSetup.push([dec2hexString(usagePage), dec2hexString(usage)]);
            return _context19.abrupt("continue", 31);
          case 30:
            return _context19.abrupt("continue", 31);
          case 31:
            reportPos += telephonyCollection.inputReports[q].items[x].reportSize;
          case 32:
            y++;
            _context19.next = 24;
            break;
          case 33:
            x++;
            _context19.next = 23;
            break;
          case 34:
            q++;
            _context19.next = 22;
            break;
          case 35:
            mylog.report(inputSetup, 'Input', myHSs[0].inputReportID);
          case 36:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
    return _initWEBHIDheadset.apply(this, arguments);
  }
  function updateHeadset() {
    return _updateHeadset.apply(this, arguments);
  } //close current headset
  function _updateHeadset() {
    _updateHeadset = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
      var state;
      return _regeneratorRuntime.wrap(function (_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            state = getState();
            byte = 0;
            if (state === INCOMING) {
              myabl.color('#FF0000', 2);
              byte |= myHSs[0].led_ring | myHSs[0].led_ringer;
            } else if (state === ACTIVE) {
              myabl.color('#FF0000', 1);
              byte |= myHSs[0].led_offhook;
            } else if (state === ACTIVE_HOLDING) {
              myabl.color('#FF0000', 1);
              byte |= myHSs[0].led_offhook | myHSs[0].led_hold;
            } else if (state === ACTIVE_INCOMING) {
              myabl.color('#FF0000', 2);
              byte |= myHSs[0].led_offhook | myHSs[0].led_ring | myHSs[0].led_ringer;
            } else if (state === ACTIVE_INCOMING_HOLDING) {
              myabl.color('#FF0000', 2);
              byte |= myHSs[0].led_offhook | myHSs[0].led_ring | myHSs[0].led_hold | myHSs[0].led_ringer;
            } else if (state === OUTGOING) {
              myabl.color('#FF0000', 1);
              byte |= myHSs[0].led_offhook;
            } else if (state === OUTGOING_HOLDING) {
              myabl.color('#FF0000', 1);
              byte |= myHSs[0].led_offhook | myHSs[0].led_hold;
            } else if (state === OUTGOING_INCOMING) {
              myabl.color('#FF0000', 2);
              byte |= myHSs[0].led_offhook | myHSs[0].led_ring | myHSs[0].led_ringer;
            } else if (state === OUTGOING_INCOMING_HOLDING) {
              myabl.color('#FF0000', 2);
              byte |= myHSs[0].led_offhook | myHSs[0].led_ring | myHSs[0].led_hold | myHSs[0].led_ringer;
            } else if (state === HOLDING) {
              myabl.color('#FF0000', 1);
              byte |= myHSs[0].led_hold;
            } else if (state === INCOMING_HOLDING) {
              myabl.color('#FF0000', 2);
              byte |= myHSs[0].led_ring | myHSs[0].led_hold | myHSs[0].led_ringer;
            } else {
              //IDLE or UNKNOWN
              if (presence != '') {
                myabl.presence(presence); //if no presence
              } else {
                myabl.color('#00FF00', 1);
              }
            }
            if (mute) {
              byte |= myHSs[0].led_mute | myHSs[0].led_microphone;
            }
            byte |= led_vendor_bit3;
            if (myHSs.length !== 0) {
              if (myHSs[0].outputReportID > 0 && deviceIsSupported) {
                logOutputReport(getStateName(state), byte);
                myHSs[0].device.sendReport(myHSs[0].outputReportID, new Uint8Array([byte]))["catch"](function (error) {
                  mylog.error('Error in SendReport webhid::updatehs ' + error);
                });
              }
            }
            if (state === INCOMING || state === INCOMING_HOLDING) {
              if (firstring) {
                firstring = false;
                myabl.play(0, 3, 1);
              }
            } else {
              firstring = true;
              myabl.play(0, 0, 0);
            }
          case 1:
          case "end":
            return _context20.stop();
        }
      }, _callee20);
    }));
    return _updateHeadset.apply(this, arguments);
  }
  function closeHeadsetList() {
    if (myHSs.length === 0) return;
    if (deviceIsSupported) postEvent('HeadsetDisconnected', myHSs[0].name);
    for (i = 0; i < myHSs.length; i++) {
      myHSs[i].device.sendReport(myHSs[0].outputReportID, new Uint8Array([0]))["catch"](function (error) {
        mylog.error('Error in SendReport webhid::closehslist ' + error);
      });
      myHSs[i].device.close();
      myHSs[i].device.oninputreport = null;
    }
    myHSs = [];
  }

  //functions for call control
  function endActive() {
    var _iterator3 = _createForOfIteratorHelper(calls.keys()),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var key = _step3.value;
        if (calls.get(key).state === 'active') {
          postEvent('EndCall', key);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  function endOutgoing() {
    var _iterator4 = _createForOfIteratorHelper(calls.keys()),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var key = _step4.value;
        if (calls.get(key).state === 'outgoing') {
          postEvent('RejectCall', key);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  function onholdActive() {
    var _iterator5 = _createForOfIteratorHelper(calls.keys()),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var key = _step5.value;
        if (calls.get(key).state === 'active') postEvent('HoldCall', key);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
  function endOldestCallIncoming() {
    oldest = Date.now();
    id = '';
    var _iterator6 = _createForOfIteratorHelper(calls.keys()),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var key = _step6.value;
        if (calls.get(key).state === 'incoming') {
          if (calls.get(key).created < oldest) {
            oldest = calls.get(key).created;
            id = key;
          }
        }
      }
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    if (id !== '') {
      postEvent('RejectCall', id);
    }
  }
  function activateOldestCallIncoming() {
    oldest = Date.now();
    id = '';
    var _iterator7 = _createForOfIteratorHelper(calls.keys()),
      _step7;
    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var key = _step7.value;
        if (calls.get(key).state === 'incoming') {
          if (calls.get(key).created < oldest) {
            oldest = calls.get(key).created;
            id = key;
          }
        }
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }
    if (id !== '') {
      postEvent('AcceptCall', id);
    }
  }
  function activateOldestCallOnhold() {
    oldest = Date.now();
    id = '';
    var _iterator8 = _createForOfIteratorHelper(calls.keys()),
      _step8;
    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var key = _step8.value;
        if (calls.get(key).state === 'onhold') {
          if (calls.get(key).active < oldest) {
            oldest = calls.get(key).active;
            id = key;
          }
        }
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
    if (id !== '') {
      postEvent('ResumeCall', id);
    }
  }
  var lastrec = 0;
  //function for receiving HID reports from headset
  function onInputReport(event) {
    var reportId = event.reportId;
    var reportData = event.data;
    var rec = reportData.getUint8(0);
    if (event.device !== myHSs[0].device) return;
    state = getState();
    if (reportId === myHSs[0].inputReportID) {
      logInputReport(getStateName(state), rec);
      if ((lastrec & myHSs[0].telephony_mute) > 0 && (rec & myHSs[0].telephony_mute) === 0) {
        mylog.message('MUTE');
        mute = !mute;
        postEvent('MuteMicrophone', mute);
      }
      if ((lastrec & myHSs[0].telephony_redial) > 0 && (rec & myHSs[0].telephony_redial) === 0) {
        mylog.message('REDIAL');
        postEvent('Redial', 0);
      }
      if ((lastrec & myHSs[0].telephony_flash) > 0 && (rec & myHSs[0].telephony_flash) === 0) {
        mylog.message('FLASH');
        if (state === ACTIVE) onholdActive();else if (state === HOLDING || state === INCOMING_HOLDING || state === ACTIVE_HOLDING || state === OUTGOING_HOLDING || state === ACTIVE_INCOMING_HOLDING || state === OUTGOING_INCOMING_HOLDING) {
          activateOldestCallOnhold();
        } else mylog.message('IGNORED');
      }
      if ((lastrec & myHSs[0].telephony_drop) > 0 && (rec & myHSs[0].telephony_drop) === 0) {
        mylog.message('DROP');
        if (state === ACTIVE_INCOMING || state === ACTIVE_INCOMING_HOLDING || state === OUTGOING_INCOMING || state === OUTGOING_INCOMING_HOLDING || state === INCOMING || state === INCOMING_HOLDING) endOldestCallIncoming();else mylog.message('IGNORED');
      }
      if ((lastrec & myHSs[0].telephony_hook) === 0 && (rec & myHSs[0].telephony_hook) > 0) {
        mylog.message('HOOK OFF');
        if (state === IDLE) {
          postEvent('Offhook', myHSs[0].name);
        } else if (state === HOLDING) {
          activateOldestCallOnhold();
        } else if (state === ACTIVE_INCOMING || state === ACTIVE_INCOMING_HOLDING || state === OUTGOING_INCOMING || state === OUTGOING_INCOMING_HOLDING || state === INCOMING || state === INCOMING_HOLDING) {
          activateOldestCallIncoming();
        } else mylog.message('IGNORED');
      }
      if ((lastrec & myHSs[0].telephony_hook) > 0 && (rec & myHSs[0].telephony_hook) === 0) {
        mylog.message('HOOK ON');
        if (state === ACTIVE || state === ACTIVE_HOLDING || state === ACTIVE_INCOMING || state === ACTIVE_INCOMING_HOLDING) {
          endActive();
        } else if (state === OUTGOING || state === OUTGOING_HOLDING || state === OUTGOING_INCOMING || state === OUTGOING_INCOMING_HOLDING) {
          endOutgoing();
        } else mylog.message('IGNORED');
      }
      lastrec = rec;
    } else {
      var _str = '';
      for (var _i = 0; _i < reportData.length; _i++) _str += dec2hexString(reportData.getUint8(_i)) + ', ';
      //mylog.error("Input Report on wrong ID: " + reportId + " : " + str);
    }
  }
  //functions to compute current state based on calls variable
  function getStateName(state) {
    switch (state) {
      case IDLE:
        return 'IDLE';
      case INCOMING:
        return 'INCOMING';
      case HOLDING:
        return 'HOLDING';
      case INCOMING_HOLDING:
        return 'INCOMING_HOLDING';
      case OUTGOING:
        return 'OUTGOING';
      case OUTGOING_INCOMING:
        return 'OUTGOING_INCOMING';
      case OUTGOING_HOLDING:
        return 'OUTGOING_HOLDING';
      case OUTGOING_INCOMING_HOLDING:
        return 'OUTGOING_INCOMING_HOLDING';
      case ACTIVE:
        return 'ACTIVE';
      case ACTIVE_INCOMING:
        return 'ACTIVE_INCOMING';
      case ACTIVE_HOLDING:
        return 'ACTIVE_HOLDING';
      case ACTIVE_INCOMING_HOLDING:
        return 'ACTIVE_INCOMING_HOLDING';
      default:
        return 'UNKNOWN';
    }
  }
  function getState() {
    var incoming = 0;
    var outgoing = 0;
    var active = 0;
    var onhold = 0;
    var _iterator9 = _createForOfIteratorHelper(calls.keys()),
      _step9;
    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var key = _step9.value;
        if (calls.get(key).state == 'incoming') incoming++;
        if (calls.get(key).state == 'outgoing') outgoing++;
        if (calls.get(key).state == 'active') active++;
        if (calls.get(key).state == 'onhold') onhold++;
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }
    if (incoming > 0 && outgoing === 0 && active === 0 && onhold === 0) return INCOMING;else if (incoming > 0 && outgoing === 0 && active === 0 && onhold > 0) return INCOMING_HOLDING;else if (incoming === 0 && outgoing === 0 && active === 1 && onhold === 0) return ACTIVE;else if (incoming === 0 && outgoing === 0 && active === 1 && onhold > 0) return ACTIVE_HOLDING;else if (incoming > 0 && outgoing === 0 && active === 1 && onhold === 0) return ACTIVE_INCOMING;else if (incoming > 0 && outgoing === 0 && active === 1 && onhold > 0) return ACTIVE_INCOMING_HOLDING;else if (incoming === 0 && outgoing === 1 && active === 0 && onhold === 0) return OUTGOING;else if (incoming === 0 && outgoing === 1 && active === 0 && onhold > 0) return OUTGOING_HOLDING;else if (incoming > 0 && outgoing === 1 && active === 0 && onhold === 0) return OUTGOING_INCOMING;else if (incoming > 0 && outgoing === 1 && active === 0 && onhold > 0) return OUTGOING_INCOMING_HOLDING;else if (incoming === 0 && outgoing === 0 && active === 0 && onhold > 0) return HOLDING;else if (incoming === 0 && outgoing === 0 && active === 0 && onhold === 0) return IDLE;else return UNKNOWN;
  }
  //event listeners for connect/disconnect
  if (navigator.hid) {
    navigator.hid.addEventListener('connect', /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref13) {
        var device;
        return _regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              device = _ref13.device;
              setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
                var _x9;
                return _regeneratorRuntime.wrap(function (_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      _x9 = 0;
                    case 1:
                      if (!(_x9 < device.collections.length)) {
                        _context11.next = 5;
                        break;
                      }
                      if (!(device.vendorId === EPOSVID && (device.collections[_x9].usagePage === VENDORPAGE || device.collections[_x9].usagePage === ALTVENDORPAGE || device.collections[_x9].usagePage === ALTVENDORPAGE2))) {
                        _context11.next = 4;
                        break;
                      }
                      mylog.connection('HID connected: ' + getDeviceName(device));
                      _context11.next = 2;
                      return addNewHeadset(device);
                    case 2:
                      _context11.next = 3;
                      return initHeadset();
                    case 3:
                      return _context11.abrupt("continue", 5);
                    case 4:
                      _x9++;
                      _context11.next = 1;
                      break;
                    case 5:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              })), 1000);
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      return function (_x8) {
        return _ref14.apply(this, arguments);
      };
    }());
    navigator.hid.addEventListener('disconnect', /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref16) {
        var device, _x1, _i2, data;
        return _regeneratorRuntime.wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              device = _ref16.device;
              _x1 = 0;
            case 1:
              if (!(_x1 < device.collections.length)) {
                _context13.next = 6;
                break;
              }
              if (!(device.vendorId === EPOSVID && (device.collections[_x1].usagePage === VENDORPAGE || device.collections[_x1].usagePage === ALTVENDORPAGE || device.collections[_x1].usagePage === ALTVENDORPAGE2))) {
                _context13.next = 5;
                break;
              }
              _i2 = 0;
            case 2:
              if (!(_i2 < myHSs.length)) {
                _context13.next = 5;
                break;
              }
              if (!(myHSs[_i2].device === device)) {
                _context13.next = 4;
                break;
              }
              mylog.connection('HID disconnected: ' + myHSs[_i2].name);
              data = {
                name: myHSs[_i2].name,
                id: myHSs[_i2].id,
                serial: myHSs[_i2].serial,
                slave1id: myHSs[_i2].slave1id.replace('EPOS_', ''),
                slave1serial: myHSs[_i2].slave1serial,
                slave2id: myHSs[_i2].slave2id.replace('EPOS_', ''),
                slave2serial: myHSs[_i2].slave2serial
              };
              postEvent('HeadsetRemoved', data);
              if (_i2 == 0) {
                if (deviceIsSupported) postEvent('HeadsetDisconnected', myHSs[0].name);
              }
              myHSs[_i2].device.close();
              myHSs.splice(_i2, 1);
              if (!(_i2 === 0)) {
                _context13.next = 3;
                break;
              }
              if (!deviceIsSupported) {
                _context13.next = 3;
                break;
              }
              _context13.next = 3;
              return initHeadset();
            case 3:
              return _context13.abrupt("return");
            case 4:
              _i2++;
              _context13.next = 2;
              break;
            case 5:
              _x1++;
              _context13.next = 1;
              break;
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      return function (_x0) {
        return _ref17.apply(this, arguments);
      };
    }());
  }
  //abl callback function
  function ablloaded(_x10, _x11) {
    return _ablloaded.apply(this, arguments);
  } //Initialization
  function _ablloaded() {
    _ablloaded = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21(msg, param) {
      return _regeneratorRuntime.wrap(function (_context21) {
        while (1) switch (_context21.prev = _context21.next) {
          case 0:
            if (msg === 'loaded') {
              mylog.init('abl.js was allocated in webhid.js');
            } else if (msg === 'devices') {
              if (mylog) mylog.message(param + ' ABL devices present');
              postEvent('BLsPresent', param);
              updateHeadset();
            } else console.log(msg + ' : ' + param);
          case 1:
          case "end":
            return _context21.stop();
        }
      }, _callee21);
    }));
    return _ablloaded.apply(this, arguments);
  }
  mylog = new log(MYCOLOR1, MYCOLOR2);
  myabl = new abl(ablloaded);
}
export default dseasdk;

/*EOF*/